import React, { Component } from 'react';

import PropTypes from 'prop-types';

import WistiaContainer from './containers/WistiaContainer';
import LandingFooter from './www/LandingFooter';
import LandingNavV2 from './www/LandingNavV2';

import 'css/components/_LandingWrapper.scss';

const routesForWhiteNav = [
  '/',
  '/case-studies/ahrefs',
  '/case-studies/agencyanalytics',
  '/case-studies/aryeo',
  '/case-studies/axios',
  '/case-studies/circleci',
  '/case-studies/clickup',
  '/case-studies/akiflow',
  '/case-studies/document360',
  '/case-studies/figured',
  '/case-studies/givebutter',
  '/case-studies/hive',
  '/case-studies/janetechnologies',
  '/case-studies/knak',
  '/case-studies/missive',
  '/case-studies/mercury',
  '/case-studies/pallyy',
  '/case-studies/readme',
  '/case-studies/stickermule',
  '/case-studies/strapi',
  '/case-studies/outlier',
  '/features/analyze-feedback',
  '/features/collect-feedback',
  '/features/product-changelog',
  '/features/product-roadmap',
  '/powered-by-canny',
  '/use-cases/feature-request-management',
  '/use-cases/idea-management',
  '/use-cases/internal-feedback',
  '/use-cases/product-management',
  '/use-cases/public-roadmap',
  '/use-cases/sales-documentation',
];

export default class LandingWrapper extends Component {
  static props = {
    location: PropTypes.object,
  };

  renderNav() {
    const {
      location: { pathname },
    } = this.props;
    const navStyle = routesForWhiteNav.includes(pathname) ? 'white' : '';

    return <LandingNavV2 navStyle={navStyle} />;
  }

  renderFooter() {
    return <LandingFooter />;
  }

  render() {
    return (
      <WistiaContainer>
        <div className="landingWrapper">
          {this.renderNav()}
          {this.props.children}
          {this.renderFooter()}
        </div>
      </WistiaContainer>
    );
  }
}
